import { render, staticRenderFns } from "./RegisterCustomerLiteForm.vue?vue&type=template&id=64aecb5c&scoped=true&lang=pug"
import script from "./RegisterCustomerLiteForm.vue?vue&type=script&lang=js"
export * from "./RegisterCustomerLiteForm.vue?vue&type=script&lang=js"
import style0 from "./RegisterCustomerLiteForm.vue?vue&type=style&index=0&id=64aecb5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64aecb5c",
  null
  
)

export default component.exports